import { useMutation, useQueryClient } from "react-query";
import mutationKeys from "reactQuery/mutationKeys";
import queryKeys from "reactQuery/queryKeys";

import { likePost } from "shared/client";

export default function useLikePost() {
  const client = useQueryClient();

  return useMutation(
    ({ postId, groupId }: { postId: string; groupId: string }) =>
      likePost(postId),
    {
      mutationKey: mutationKeys.likePost,
      onSettled: (data, error, variables) => {
        client.invalidateQueries(
          queryKeys.posts(variables.groupId, {}).slice(0, 2)
        );
      },
    }
  );
}
